module.exports = __webpack_public_path__ + "media/Blob 8 Joins.d1dbd877.mp3";